module.exports = __webpack_public_path__ + "img/yzm.9fd273ae.png";